export const HANDLE_GET_CUSTOMERS = "HANDLE_GET_CUSTOMERS";

export interface HandleGetCustomers {
    type: typeof HANDLE_GET_CUSTOMERS;
    payload: {locationId ?:number,customerNumber ?: string,  callback: (res) => void;};
}

